import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=55c1b24f&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=55c1b24f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c1b24f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55c1b24f')) {
      api.createRecord('55c1b24f', component.options)
    } else {
      api.reload('55c1b24f', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=55c1b24f&scoped=true&", function () {
      api.rerender('55c1b24f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UENxzTYrWS7Q/JS/comp/PopupBox.vue"
export default component.exports